import clsx from "clsx";
import type { FC } from "react";
import { useMemo } from "react";
import classes from "./Alert.module.scss";

export interface AlertProps {
	title: string;
	stage: string;
	className?: string;
}

export interface AlertComponent extends FC<AlertProps> {}

export const Alert: AlertComponent = ({ title, stage, className }) => {
	const wrapperClassName = useMemo(
		() =>
			clsx(
				classes.wrapper,

				{},
				className
			),
		[className]
	);

	return (
		<div className={wrapperClassName}>
			<div className={classes.content}>
				<span className={classes.title}>{title}</span>
				<div className={classes.stage}>{stage}</div>
			</div>
		</div>
	);
};
